<template src="./template.html"></template>
<script>
import _find from 'lodash/find'
import { mapState } from 'vuex'

export default {
  name: 'inventory-list-item',
  props: {
    inventory: {
      type: Object,
      required: true,
    },
    //THEMEING
    theme: {
      type: String,
      default: 'theme-light',
    },
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
    }),
    venue() {
      return this.$store.state.venue.current || {}
    },
  },
  methods: {
    onClick() {
      this.$emit('onClick', this.inventory)
    },
    onMouseover() {
      this.$emit('onMouseover', this.inventory)
    },
    onMouseleave() {
      this.$emit('onMouseleave', this.inventory)
    },
    getSoldOutTiers() {
      if (!this.inventory || !this.inventory.tier || !this.inventory.tier.levels || !this.inventory.tier.levels.length) return []

      const activeLevel = _find(this.inventory.tier.levels, {
        _id: this.inventory.tier.activeLevel,
      })
      const activeLevelIndex = this.inventory.tier.levels.indexOf(activeLevel)

      const levels = this.inventory.tier.levels.slice(0, activeLevelIndex).map((tier) => {
        tier.name = this.inventory.name
        return tier
      })

      return levels.length > 1 ? levels.slice(Math.max(levels.length - 1, 1)) : levels
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/InventoryListItem/index.vue